import { Flexbox, Form, QuickFilter } from '@/components'
import useQuery from '@/hooks/useQuery'
import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import qs from 'qs'

function OrderCastrations() {
  const [active, setActive] = useState(false)
  const query = useQuery()
  const location = useLocation()
  const history = useHistory()
  const orderField = query?.o?.orderField || 'createdAt'
  const orderDirection = query?.o?.orderDirection || 'DESC'

  function updateOrder(orderUpdate) {
    const newQuery = {
      ...query,
      o: { ...query.o, ...orderUpdate },
      page: 1,
    }
    history.replace({
      pathname: location.pathname,
      search: `?${qs.stringify(newQuery)}`,
    })
  }

  function handleChangeOrderField(newOrderField) {
    updateOrder({ orderField: newOrderField })
  }

  function handleChangeOrderDirection(newOrderDirection) {
    updateOrder({ orderDirection: newOrderDirection })
  }

  return (
    <>
      <a
        className="btn btn-link tooltip tooltip-left"
        onClick={() => setActive(true)}
        data-tooltip="Ordenar castrações"
      >
        <i className="fas fa-sort-amount-up" />
      </a>
      <div className={`modal ${active ? 'active' : ''}`}>
        <a
          type="button"
          className="modal-overlay"
          aria-label="Close"
          onClick={() => setActive(false)}
        />
        <div className="modal-container">
          <div className="modal-header">
            <a
              type="button"
              className="btn btn-clear float-right"
              onClick={() => setActive(false)}
            />
            <div className="modal-title h5">Ordenar castrações</div>
          </div>
          <div className="modal-body">
            <QuickFilter
              initialValues={{
                orderField,
                orderDirection,
              }}
              title="Filtrar"
              autoSubmit
              queryAttribute="o"
              renderForm={() => (
                <>
                  <Flexbox.Column className="col-6 mt-2">
                    <Form.Group>
                      <Form.Label
                        className="label-sm pt-2"
                        htmlFor="orderField"
                      >
                        Ordenar por
                      </Form.Label>
                      <Form.ValidationField name="orderField">
                        {({ field }) => (
                          <Form.Select
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            {...field}
                            id="orderField"
                            className="select-sm"
                            placeholder="Data de referência"
                            onChange={(e) => {
                              field.onChange(e)
                              handleChangeOrderField(e.target.value)
                            }}
                          >
                            <option value="createdAt">Data de solicitação (padrão)</option>
                            <option value="approvedAt">Data de aprovação</option>
                            <option value="canceledAt">Data de cancelamento</option>
                            <option value="startedAt">Data de início</option>
                            <option value="performedAt">Data de finalização</option>
                            <option value="scheduledTo">Data de agendamento</option>
                            <option value="rejectedAt">Data de rejeição</option>
                            <option value="preApprovedAt">Data de pré-aprovação</option>
                          </Form.Select>
                        )}
                      </Form.ValidationField>
                    </Form.Group>
                  </Flexbox.Column>
                  <Flexbox.Column className="col-6 mt-2">
                    <Form.Group>
                      <Form.Label
                        className="label-sm pt-2"
                        htmlFor="orderDirection"
                      >
                        Ordem
                      </Form.Label>
                      <Form.ValidationField name="orderDirection">
                        {({ field }) => (
                          <Form.Select
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            {...field}
                            id="orderDirection"
                            className="select-sm"
                            placeholder="Ordem"
                            onChange={(e) => {
                              field.onChange(e)
                              handleChangeOrderDirection(e.target.value)
                            }}
                          >
                            <option value="DESC">
                              Do mais recente ao mais antigo
                            </option>
                            <option value="ASC">
                              Do mais antigo ao mais recente
                            </option>
                          </Form.Select>
                        )}
                      </Form.ValidationField>
                    </Form.Group>
                  </Flexbox.Column>
                </>
              )}
            />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => setActive(false)}
            >
              <i className="fas fa-check" />
              &nbsp;Ok
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default OrderCastrations
